export default "__VITE_ASSET__35d3a118__$_?component__"